// Work / operations videos. Add new items to `videos` and they appear on the landing page.
// Supported URL types:
//  - mp4 (direct file URL)
//  - youtube / vimeo embed URL
// If videos[] is empty, the section is hidden.

export const videos = [
  // {
  //   id: "op-001",
  //   type: "mp4", // "mp4" | "youtube" | "vimeo"
  //   url: "https://.../warehouse-tour.mp4",
  //   poster: "https://.../poster.jpg", // optional, used for mp4
  //   title_en: "Inside our Istanbul warehouse",
  //   title_ar: "داخل مستودعنا في إسطنبول",
  //   title_fr: "Dans notre entrepôt d'Istanbul",
  // },
];
